<div mat-dialog-title class="modal-header">
  <h4 class="title">{{ editMode ? 'Edit' : 'New' }} User</h4>
  <button mat-icon-button class="close-button" (click)="onCancel()">
    <mat-icon>close</mat-icon>
  </button>
</div>

<hr class="divider" />

@if (editMode) {
  <div class="info-container">
    <div class="info-container">
      <div class="avatar-container" (click)="fileInput.click()">
        <!-- Default Avatar -->
        @if (!previewUrl) {
          <img
            src="assets/images/avatar.png"
            class="avatar"
            alt="Avatar"
            />
        }
        <div class="avatar-overlay">
          <mat-icon class="upload-icon">file_upload</mat-icon>
        </div>
        <input hidden #fileInput type="file" (change)="onFileSelected($event)" />
        <!-- Selected Avatar -->
        @if (previewUrl) {
          <img
            [src]="previewUrl"
            alt="Preview"
            class="avatar preview-image"
            />
        }
      </div>
    </div>
    <div class="text-container">
      <h3 class="name-info">{{ firstName }} {{ lastName }}</h3>
      <!--<span class="last-login-info">Last login: {{ lastLogin }}</span>-->
    </div>
  </div>
}

<form [formGroup]="userForm" class="user-form">
  <mat-dialog-content class="form-container">
    <div class="input-row">
      <!-- First Name -->
      <mat-form-field class="input-field" appearance="outline">
        <mat-label>First Name</mat-label>
        <input matInput formControlName="firstName" type="text" />
        @if (userForm.get('firstName')?.hasError('required')) {
          <mat-error>
            The First Name is required
          </mat-error>
        }
        @if (userForm.get('firstName')?.hasError('whitespace')) {
          <mat-error>
            The First Name cannot contain white space
          </mat-error>
        }
        @if (userForm.get('firstName')?.hasError('specialChars')) {
          <mat-error>
            The First Name cannot contain special characters
          </mat-error>
        }
      </mat-form-field>
      <!-- Last Name -->
      <mat-form-field class="input-field" appearance="outline">
        <mat-label>Last Name</mat-label>
        <input matInput formControlName="lastName" type="text" />
        @if (userForm.get('lastName')?.hasError('required')) {
          <mat-error>
            The Last Name is required
          </mat-error>
        }
        @if (userForm.get('lastName')?.hasError('whitespace')) {
          <mat-error>
            The Last Name cannot cannot contain white space
          </mat-error>
        }
        @if (userForm.get('lastName')?.hasError('specialChars')) {
          <mat-error>
            The Last Name cannot contain special characters
          </mat-error>
        }
      </mat-form-field>
    </div>

    <div class="input-row">
      <!-- Email -->
      <mat-form-field class="input-field" appearance="outline">
        <mat-label>Email</mat-label>
        <input matInput formControlName="email" type="email" />
        @if (userForm.get('email')?.hasError('required')) {
          <mat-error
            >The Email is required</mat-error
            >
          }
          @if (userForm.get('email')?.hasError('email')) {
            <mat-error
              >The Email has to be valid</mat-error
              >
            }
          </mat-form-field>
          <!-- Password -->
          <!--<mat-form-field class="input-field" appearance="outline">
          <mat-label>Password</mat-label>
          <input matInput formControlName="password" type="password" />
          <mat-error *ngIf="userForm.get('password')?.hasError('required')"
            >The Password is required</mat-error
            >
          </mat-form-field>-->
          <!-- Role -->
          <mat-form-field class="input-field" appearance="outline">
            <mat-label>Role</mat-label>
            <mat-select formControlName="role" [disabled]="true">
              @for (role of roles; track role) {
                <mat-option [value]="role.value">
                  {{ role.value }}
                </mat-option>
              }
            </mat-select>
            @if (userForm.get('role')?.hasError('required')) {
              <mat-error
                >The Role is required</mat-error
                >
              }
            </mat-form-field>
          </div>
        </mat-dialog-content>

        <mat-dialog-actions class="action-buttons">
          <app-button
            mat-button
            (click)="onDelete()"
            [label]="'Delete User'"
            [icon]="'delete'"
            [isIcon]="false"
            [isDelete]="true"
            [buttonType]="'stroked-button'"
            [ngStyle]="{ visibility: editMode ? 'visible' : 'hidden' }"
            [isDisabled]="isDisabled"
          ></app-button>
          <app-button
            mat-button
            (click)="onSave()"
            [label]="'Save Changes'"
            [icon]="'check_circle_outline'"
            [isDisabled]="isOnSaveDisabled()"
          ></app-button>
        </mat-dialog-actions>
      </form>
